import React from 'react'
import PropTypes from 'prop-types'
import { Text, Button } from 'shared/components'

import * as styles from './styles'

const ResetPasswordModalComponent = ({ isVisible, onCancel, onConfirm }) => {
	if (!isVisible) return null

	return (
		<div css={styles.overlay}>
			<div css={styles.modal}>
				<div css={styles.content}>
					<Text css={styles.title}>
						Reset Password
					</Text>
					<Text css={styles.message}>
						Do you really want to reset your password?
					</Text>
				</div>

				<div css={styles.buttonContainer}>
					<Button
						css={styles.noButton}
						onClick={onCancel}
					>
						<Text css={styles.noButtonText}>
							No
						</Text>
					</Button>

					<Button
						css={styles.yesButton}
						onClick={onConfirm}
					>
						<Text css={styles.yesButtonText}>
							Yes
						</Text>
					</Button>
				</div>
			</div>
		</div>
	)
}

ResetPasswordModalComponent.propTypes = {
	isVisible: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
}

export default ResetPasswordModalComponent 